// extracted by mini-css-extract-plugin
export default {"link":"MetricDetailsCellRenderer_link__qng6N"};